import { Box, Grid2, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import CustomButton from "../../components/common/CustomButton";
import TableWallet from "../../components/wallet/TableWallet";
import ResponsiveTableWallet from "../../components/wallet/Resposive/ResponsiveTableWallet";
import ModalDeposit from "../../components/modal/ModalDeposit";
import ModalWithDraw from "../../components/modal/ModalWithDraw";
import { RootContext } from "../../components/layout";
import { getFormattedDateTime } from "../../Utils/helper";



export default function Wallet() {
  const { balances, setBalances } = useContext(RootContext);
  const [openDeposit, setOpenDeposit] = useState(false);
  const [openWithDraw, setOpenWithDraw] = useState(false);
  const handleDeposit = (amount = 5000) => {
    setBalances([
      {
        id: "06c1774-7f3d-46ad...90a8",
        type: "deposit",
        amount: amount,
        balance: Number(amount) + balances[0].balance,
        date: getFormattedDateTime(),
      },
      ...balances,
    ]);
  };
  const handleWithDraw = (amount = 5000) => {
    setBalances([
      {
        id: "06c1774-7f3d-46ad...90a8",
        type: "withdraw",
        amount: amount,
        balance: balances[0].balance - amount,
        date: getFormattedDateTime(),
      },
      ...balances,
    ]);
  };
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      sx={{
        justifyContent: "space-between",
        paddingTop: { xs: 5, sm: 5, md: 5 },
      }}
    >
      <Grid2
        container
        padding={3}
        bgcolor="#191922"
        borderRadius="8px"
        spacing={3}
      >
        <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
          <Box
            sx={{
              backgroundImage: "url(/images/image/bg-image.png)", // Replace with your image URL
              backgroundSize: "cover", // Cover the entire box
              backgroundPosition: "center", // Center the image
              backgroundRepeat: "no-repeat", // Prevent the image from repeating
              minHeight: 92,
              minWidth: 200,
              color: "black",
              borderRadius: "16px",
              padding: "24px",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography variant="body" fontWeight={500}>
              Current Balance
            </Typography>
            <Typography variant="body" fontWeight={700}>
              ${Number(balances[0].balance).toLocaleString("en-US")}
            </Typography>
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 12, md: 8, lg: 8 }}>
          <Box>
            <Grid2
              width={{ xs: "100%", md: "100%", lg: "50%" }}
              container
              spacing={2}
            >
              <Grid2 size={6}>
                <CustomButton
                  handleClick={() => {
                    setOpenDeposit(true);
                  }}
                >
                  Deposit
                </CustomButton>
              </Grid2>
              <Grid2 size={6}>
                <CustomButton
                  handleClick={() => {
                    setOpenWithDraw(true);
                  }}
                  bgcolor="#F1F5F9"
                  color="black"
                >
                  Withdraw
                </CustomButton>
              </Grid2>
            </Grid2>
          </Box>
        </Grid2>
      </Grid2>
      <TableWallet
        data={balances}
        display={{ xs: "none", sm: "none", md: "block" }}
      />
      <ResponsiveTableWallet
        data={balances}
        display={{ xs: "block", sm: "block", md: "none" }}
      />
      <ModalDeposit
        open={openDeposit}
        handleDeposit={handleDeposit}
        handleClose={() => {
          setOpenDeposit(false);
        }}
      />
      <ModalWithDraw
        handleWithDraw={handleWithDraw}
        open={openWithDraw}
        handleClose={() => {
          setOpenWithDraw(false);
        }}
      />
    </Box>
  );
}
